import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import './i18n';
import { initPrivacyMask } from './utils/privacyMask';

initPrivacyMask();

const container = document.getElementById("root");

// The static index.html ships SEO content inside #root for crawlers (esp. Yandex,
// which renders JS poorly). createRoot replaces that content with the live app on mount.
createRoot(container).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
